import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "name",
    "finalDriveAssessmentName",
    "validationPanel",
    "validationMessage"
  ]

  connect() { }

  validate(event) {
    const errors = this.validateForm();
    
    if (errors.length > 0) {
      event.preventDefault();
      this.showValidationPanel(errors.join("<br>"));
      return;
    }    
  }

  validateForm() {
    let validationErrors = [];

    const name = this.nameTarget;
    if (name.value.trim() === "") {
      validationErrors.push("Program name cannot be empty.");
    }

    const finalDriveAssessmentName = this.finalDriveAssessmentNameTarget;
    if (finalDriveAssessmentName.value.trim() === "") {
      validationErrors.push("Final drive assessment name cannot be empty.");
    }
    
    return validationErrors;
  }

  showValidationPanel(message) {
    const validationPanel = this.validationPanelTarget;
    const validationMessage = this.validationMessageTarget;
  
    validationMessage.innerHTML = message;
    validationPanel.hidden = false;
    validationMessage.hidden = false;
  }
}
